import * as React from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import Icon from "./Icon";
import Delayed from "./Delayed";
const Container = styled.span`
  display: inline-flex;
  align-items: center;
  vertical-align: baseline;
`;
const StyledIcon = styled(Icon)(
  ({ $displayMargin }) => css`
    ${$displayMargin ? "margin-right: 6px;" : ""}
  `
);
const Spinner = ({ name = "progress_activity", text = void 0, delay = 200, ...rest }) => {
  const { t } = useTranslation("common");
  const displayedText = text != null ? text : t("loading");
  return /* @__PURE__ */ React.createElement(Delayed, { delay }, /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(StyledIcon, { ...rest, name, $displayMargin: !!(displayedText == null ? void 0 : displayedText.trim()), spin: true }), displayedText));
};
export default Spinner;
